// showAlert.js
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

export const showAlert = (type, message) => {
  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <div className="custom-alert-container">
          <div className={`custom-alert ${type}`}>
            <div className="custom-alert-header">
              <h2>{type === 'success' ? 'Success 🎉' : 'Error ⚠️'}</h2>
            </div>
            <div className="custom-alert-body">
              <p>{message}</p>
            </div>
            <button
              className={`btn-save-meal confirmbtn ${type === 'success' ? 'success-btn' : 'error-btn'}`}
              onClick={onClose}
            >
              OK
            </button>
          </div>
        </div>
      );
    },
  });
};

export default showAlert;
